import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style1">
      <div className="container">
        <div className="top-content section-padding">
          <div className="row gx-0">
            <div className="col-lg-4">
              <div className="info-side">
                <div className="text fsz-24 color-333 lh-3 fw-600">
                 Independent artist creating custom illustrations and unique designs that bring your ideas to life.
                </div>
                <div className="foot-social mt-50">
                   <a href="https://wa.me/9895096500" target="_blank">
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href="https://www.instagram.com/af.thab._?utm_source=qr&igsh=cm1vazZtNzE1NDhk" target="_blank">
                <i className="fab fa-instagram"></i>
              </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 offset-lg-2">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Links </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#aboutme">About Me</a>
                  </li>
                  <li>
                    <a href="#myart">My Works</a>
                  </li>
                  <li>
                    <a href="#contact">Contact</a>
                  </li>
                 
                </ul>
              </div>
             
            </div>
            <div className="col-lg-3">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Address </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#">Kozhikode,Kerala</a>
                  </li>
                  <li>
                    <a href="mailto:afthab98950@gmail.com"> afthab98950@gmail.com</a>
                  </li>
                  <li>
                    <a href="tel:9895096500"> +91 9895096500 </a>
                  </li>
                </ul>
              </div>
              
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row">
            <div className="col-lg-12">
              <p className="fsz-13 cpyright">© 2025 Afthab Rahman. All Right Reserved</p>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
